import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpMethods } from '@cbre/http';
import { HttpClient } from '@angular/common/http';
import { HelpTicket, Attachment } from '@shared/models/help-ticket.model';

@Injectable({
  providedIn: 'root',
})
export class ServiceTicketService extends HttpMethods {
  constructor(http: HttpClient) {
    super(http);
  }
  public createServiceTicket(ticketInfo: HelpTicket): Observable<number> {
    const uri = `/help/ticket`;
    return <Observable<number>>this.httpPost(uri, ticketInfo);
  }
  public uploadFile(file): Observable<Attachment> {
    const uri = `/help/attachments`;
    return <Observable<Attachment>>this.httpPost(uri, file);
  }
}
